import { StatusTag } from '@aigc/components';
import { useStateChange } from '@aigc/hooks';
import { SyncOutlined } from '@ant-design/icons';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getOneScriptQueryOptions } from '../../script/api';
import { ScriptStatus } from '../../script/model';
import type { ScriptListItemDto } from '../../script/script.dto';

export const TaskStatus = (props: { script: ScriptListItemDto }) => {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    enabled: (query) => {
      const status = (query.state.data ?? props.script).status;
      return status !== ScriptStatus.成功 && status !== ScriptStatus.失败;
    },
    ...getOneScriptQueryOptions(props.script.id),
    initialData: props.script,
    staleTime: 5000,
    refetchInterval: (query) => {
      if (
        query.state.data?.status === ScriptStatus.成功 ||
        query.state.data?.status === ScriptStatus.失败
      ) {
        return false;
      }

      return 5000;
    },
  });

  useStateChange([data], ({ isInitial, current }) => {
    if (isInitial) {
      return;
    }

    const [currentData] = current;

    if (
      currentData.status === ScriptStatus.成功 ||
      currentData.status === ScriptStatus.失败
    ) {
      queryClient.invalidateQueries({
        queryKey: ['脚本列表'],
      });
    }
  });

  switch (data.status) {
    case ScriptStatus.失败:
    case ScriptStatus.成功:
      return;
    default:
      return (
        <StatusTag
          variant="filled"
          color="processing"
          icon={<SyncOutlined spin />}
          active
        >
          分析中
        </StatusTag>
      );
  }
};
